import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
const cardElementOptions = {
    style: {
        base: {
            fontSize: "16px",
            color: "#424770",
            "::placeholder": { color: "#aab7c4" },
            backgroundColor: "#fff",
            padding: "10px"
        },
        invalid: { color: "#9e2146" }
    }
};
export default function ClientPlans() {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [loadingPayment, setLoadingPayment] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [lists, setLists] = useState([]);
    const [clientPlans, setClientPlans] = useState([]);
    const [values, setValues] = useState({});
    const [userData, setUserData] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [clientSecret, setClientSecret] = useState("");
    const [inputValues, setInputValues] = useState({});
    const [refreshKey, setRefreshKey] = useState(0);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const handleSubmit = (e, data, amount, cycle) => {
        e.preventDefault();
        var startDate = new Date();
        var endDate = new Date();
        var renewalDate = new Date();
        var creditstotal = 0;
        if (cycle === "MONTH") {
            endDate.setMonth(startDate.getMonth() + 1);
            renewalDate.setDate(endDate.getDate() + 1);
            creditstotal = parseInt(data.credits) * 1;
        }
        if (cycle === "SIX") {
            endDate.setMonth(startDate.getMonth() + 6);
            renewalDate.setDate(endDate.getDate() + 1);
            creditstotal = parseInt(data.credits) * 6;
        }
        if (cycle === "YEAR") {
            endDate.setMonth(startDate.getMonth() + 12);
            renewalDate.setDate(endDate.getDate() + 1);
            creditstotal = parseInt(data.credits) * 12;
        }
        var formData = {
            "clientSubscriptionId": "00000000-0000-0000-0000-000000000000",
            "subscriptionId": data.subscriptionId,
            "clientId": localStorage.getItem('clientId'),
            "startDate": moment(startDate).format('YYYY-MM-DD'),
            "endDate": moment(endDate).format('YYYY-MM-DD'),
            "renewalDate": moment(renewalDate).format('YYYY-MM-DD'),
            "createdDate": moment(new Date()).format('YYYY-MM-DD'),
            "updatedDate": moment(new Date()).format('YYYY-MM-DD'),
            "isActive": true,
            "amount": parseInt(amount),
            "comment": "Subscription Payment",
            "credits": parseInt(creditstotal),
        }
        setInputValues(formData);
        var formTData = {
            "clientId": localStorage.getItem('clientId'),
            "userId": localStorage.getItem('userId'),
            "credits": parseInt(creditstotal),
            "type": "CREDITED",
            "transactionDate": moment(new Date()).format('YYYY-MM-DD'),
            "status": "SUCCESS",
            "amount": parseInt(amount),
            "comment": "Subscription Payment"
        }
        setValues(formTData);
        GetPaymentKey(data);
    };
    const GetPaymentKey = (data) => {
        axios.post(config.APIACTIVATEURL + config.CREATEPAYMENTTRANSACTION + "?Amount=" + parseFloat(data.fee) * 100, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClientSecret(response.data.data);
                    setShowCard(true);
                }
                else {
                    setLoading(false);
                }
            });
    };
    const handlePayment = (e) => {
        MakePayment(e);
    }
    const MakePayment = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        const cardElement = elements.getElement(CardElement);
        if (!cardElement) {
            console.error("CardElement is not found.");
            return;
        }
        setLoading(true);
        setLoadingPayment(true);
        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: { card: cardElement }
        });
        if (result.error) {
            handleError(result.error.message);
        } else {
            InsertSubscription();
        }
    }
    const InsertSubscription = () => {
        axios.post(config.APIACTIVATEURL + config.CREATECLIENTSUBSCRIPTION, inputValues, { ...headerconfig })
            .then((response) => {
                console.log(response);
                if (response.data.statusCode === 200) {
                    GetClientData();
                    GetData();
                    handleSuccess("Subscription Updated Successfully");
                    setShowCard(false);
                    setLoading(false);
                    setLoadingPayment(false);
                    setRefreshKey((prevKey) => prevKey + 1); // Triggers re-render
                }
            });
    };
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETSUBSCRIPTIONS + "?pageNumber=1&pageSize=20", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data.data);
                }
            });
    };
    const GetClientData = () => {
        axios.get(config.APIACTIVATEURL + config.GETCLIENTBYID + "/" + localStorage.getItem("clientId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setUserData(response.data.data);
                }
                else {
                    setUserData({});
                }
            });
    }
    useEffect(() => {
        GetData();
        GetClientData();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader key={refreshKey}></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">Subscription Plans</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="row justify-content-center mt-3">
                                        <div className="col-lg-5">
                                            <div className="text-center pb-2">
                                                <h4 className="fw-semibold fs-22">Choose the plan that's right for you</h4>
                                                <p className="text-muted mb-4 fs-15">Simple pricing. No hidden fees.</p>
                                                <span className="text-start ms-xl-2">
                                                    <span className="d-none d-xl-inline-block fs-12 badge bg-success">Current Plan : {userData.subscriptionName}</span>
                                                    <br></br>
                                                    <span className="d-none d-xl-inline-block fs-12 mt-3 badge bg-warning">Auto Renews on {moment(userData.endDate).format("DD MMM YYYY")}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showCard ? (
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h5>Please provide card details</h5>
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="border border-gray-300 rounded-md p-3">
                                                        <CardElement options={cardElementOptions} />
                                                    </div>
                                                    {loadingPayment === false ?
                                                        <button onClick={handlePayment} className="w-full btn btn-primary mt-4">Proceed to Payment</button>
                                                        :
                                                        <button disabled className="w-full btn btn-primary mt-4">Processing...</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) :
                            <>
                                <div className="row justify-content-center">
                                    <div className="card align-items-center justify-content-between">
                                        <ul className="nav nav-pills arrow-navtabs nav-success mt-3 mb-3" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-bs-toggle="tab" href={"#arrow-month"} role="tab">
                                                    <span className="d-block d-sm-none"><i className="mdi mdi-home-variant" /></span>
                                                    <span className="d-none d-sm-block">Monthly</span>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" data-bs-toggle="tab" href={"#arrow-six"} role="tab">
                                                    <span className="d-block d-sm-none"><i className="mdi mdi-account" /></span>
                                                    <span className="d-none d-sm-block">6 Months <span className="badge bg-success">10% Off</span></span>

                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" data-bs-toggle="tab" href={"#arrow-year"} role="tab">
                                                    <span className="d-block d-sm-none"><i className="mdi mdi-email" /></span>
                                                    <span className="d-none d-sm-block">Annual <span className="badge bg-success">20% Off</span></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content text-black">
                                    <div className="tab-pane active" id={"arrow-month"} role="tabpanel">
                                        <div className="row">
                                            {lists.length > 0 && lists.map((li, index) =>
                                                <>
                                                    {li.type !== "TRAIL" ?

                                                        <div className="col-4">
                                                            <div className="card pricing-box">
                                                                <div className="card-body p-2 m-2">
                                                                    <div className="d-flex align-items-center p-2">
                                                                        <div className="flex-grow-1">
                                                                            <h5 className="mb-1 fw-semibold bg-soft-primary p-2 text-black">{li.subscriptionName}</h5>
                                                                        </div>
                                                                    </div>
                                                                    <ul class="list-unstyled vstack gap-3 mb-0 mt-2">
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Price</b> : ${li.fee}/month</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">MCA Processing</b>: Includes <b>{li.credits} Credits per month</b></li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Data Entry</b>: App and Bank Statements, and Broker Sync 360 auto-matches to funders</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Funders Matching</b>: Fully automated funder matching & submission</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Funder Matrix</b> : Access to <b>{li.fundersAccess}</b> funders</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Users Included</b> : <b>{li.totalUsers} Seat</b></li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Unused Purchased Credits Roll Over</b> to future months</li>
                                                                    </ul>
                                                                    <div className="mt-4">
                                                                        {userData.subscriptionId === li.subscriptionId ?
                                                                            <button className="btn btn-success w-100 disabled">CURRENT PLAN</button>
                                                                            :
                                                                            li.fee === 1 ?
                                                                                <button className="btn btn-success w-100 waves-effect waves-light disabled">Free Trail</button>
                                                                                :
                                                                                <button className="btn btn-success w-100 waves-effect waves-light" onClick={(e) => handleSubmit(e, li, li.fee, "MONTH")}>CHANGE PLAN</button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ""}</>
                                            )}
                                        </div>
                                    </div>
                                    <div className="tab-pane" id={"arrow-six"} role="tabpanel">
                                        <div className="row">
                                            {lists.length > 0 && lists.map((li, index) =>
                                                <>
                                                    {li.type !== "TRAIL" ?

                                                        <div className="col-4">
                                                            <div className="card pricing-box">
                                                                <div className="card-body p-2 m-2">
                                                                    <div className="d-flex align-items-center p-2">
                                                                        <div className="flex-grow-1">
                                                                            <h5 className="mb-1 fw-semibold bg-soft-primary p-2 text-black">{li.subscriptionName}</h5>
                                                                        </div>
                                                                    </div>
                                                                    <ul class="list-unstyled vstack gap-3 mb-0 mt-2">
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Price</b> : ${li.sixMonthsFee}/month</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">MCA Processing</b>: Includes <b>{li.credits} Credits per month</b></li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Data Entry</b>: App and Bank Statements, and Broker Sync 360 auto-matches to funders</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Funders Matching</b>: Fully automated funder matching & submission</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Funder Matrix</b> : Access to <b>{li.fundersAccess}</b> funders</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Users Included</b> : <b>{li.totalUsers} Seat</b></li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Unused Purchased Credits Roll Over</b> to future months</li>
                                                                    </ul>
                                                                    <div className="mt-4">
                                                                        {userData.subscriptionId === li.subscriptionId ?
                                                                            <button className="btn btn-success w-100 disabled">CURRENT PLAN</button>
                                                                            :
                                                                            li.fee === 1 ?
                                                                                <button className="btn btn-success w-100 waves-effect waves-light disabled">Free Trail</button>
                                                                                :
                                                                                <button className="btn btn-success w-100 waves-effect waves-light" onClick={(e) => handleSubmit(e, li, li.sixMonthsFee, "SIX")}>CHANGE PLAN</button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ""}</>
                                            )}
                                        </div>
                                    </div>
                                    <div className="tab-pane" id={"arrow-year"} role="tabpanel">
                                        <div className="row">
                                            {lists.length > 0 && lists.map((li, index) =>
                                                <>
                                                    {li.type !== "TRAIL" ?

                                                        <div className="col-4">
                                                            <div className="card pricing-box">
                                                                <div className="card-body p-2 m-2">
                                                                    <div className="d-flex align-items-center p-2">
                                                                        <div className="flex-grow-1">
                                                                            <h5 className="mb-1 fw-semibold bg-soft-primary p-2 text-black">{li.subscriptionName}</h5>
                                                                        </div>
                                                                    </div>
                                                                    <ul class="list-unstyled vstack gap-3 mb-0 mt-2">
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Price</b> : ${li.tweleveMonthsFee}/month</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">MCA Processing</b>: Includes <b>{li.credits} Credits per month</b></li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Data Entry</b>: App and Bank Statements, and Broker Sync 360 auto-matches to funders</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Funders Matching</b>: Fully automated funder matching & submission</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Funder Matrix</b> : Access to <b>{li.fundersAccess}</b> funders</li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Users Included</b> : <b>{li.totalUsers} Seat</b></li>
                                                                        <li><i className="ri-checkbox-circle-fill fs-15 align-middle text-success mr-2"></i><b className="me-2">Unused Purchased Credits Roll Over</b> to future months</li>
                                                                    </ul>
                                                                    <div className="mt-4">
                                                                        {userData.subscriptionId === li.subscriptionId ?
                                                                            <button className="btn btn-success w-100 disabled">CURRENT PLAN</button>
                                                                            :
                                                                            li.fee === 1 ?
                                                                                <button className="btn btn-success w-100 waves-effect waves-light disabled">Free Trail</button>
                                                                                :
                                                                                <button className="btn btn-success w-100 waves-effect waves-light" onClick={(e) => handleSubmit(e, li, li.tweleveMonthsFee, "YEAR")}>CHANGE PLAN</button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ""}</>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div >
    );
}